import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 py-20">
        {/* HERO SECTION */}
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-800 leading-tight">
            Official Internship Certificate <br />
            Verification Portal
          </h1>

          <p className="text-slate-500 text-lg mt-6">
            SmartGoNext issues internship certificates to students who
            successfully complete its programs. Use this Internship Verification Portal to quickly verify authenticity and view certificate details using the certificate ID.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
            <button
              onClick={() => navigate("/verify")}
              className="px-8 py-3 bg-indigo-600 text-white rounded-xl text-lg
                hover:bg-indigo-700 transition"
            >
              Verify Certificate
            </button>

            <button
              onClick={() => navigate("/admin/login")}
              className="px-8 py-3 border border-slate-300 rounded-xl text-lg
                hover:bg-slate-100 transition"
            >
              Admin Login
            </button>
          </div>
        </div>

        {/* INFORMATION CARDS */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-24">
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 text-center">
            <h3 className="font-semibold text-slate-800 mb-2">
              Official Certificate Issuance
            </h3>
            <p className="text-sm text-slate-500">
              Internship certificates are officially issued by
              SmartGoNext after successful completion of internship
              programs.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 text-center">
            <h3 className="font-semibold text-slate-800 mb-2">
              Authenticity Verification
            </h3>
            <p className="text-sm text-slate-500">
              Anyone can verify the authenticity of a SmartGoNext
              internship certificate using its unique certificate ID.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 text-center">
            <h3 className="font-semibold text-slate-800 mb-2">
              Trusted & Transparent
            </h3>
            <p className="text-sm text-slate-500">
              This verification system ensures transparency, trust, and
              credibility for certificates issued by SmartGoNext.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
